import { useLocalStorageState } from '@srm/ui/hooks/useLocalStorageState';
import { useOptionalUsername } from '@hooks/useOptionalUsername';

export const completionAutoOpenStorageKey = (username: string): string => `user-${username}.documentCompletionAutoOpen`;

/**
 * Открывать ли панель «Заполнение» при открытии документа. Скрыл панель — она не
 * появляется сама до тех пор, пока пользователь не откроет её снова.
 * Карточка документа рендерится и без redux (тесты, стори) — тогда ключ без имени.
 */
export const useCompletionAutoOpen = () => {
    return useLocalStorageState<boolean>(completionAutoOpenStorageKey(useOptionalUsername()), true);
};
